export class SearchStatus {

    public hasResults: boolean = false;

    public recordCount: number = 0;

    public message: string;
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/models/search-status.model.ts